import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "ab-add-apm-callout",
  templateUrl: "./add-apm-callout.component.html",
})
export class AddApmCalloutComponent {
  @Input() public project: any;
  @Output() public dismiss = new EventEmitter<void>();

  public dismissCallout() {
    this.dismiss.emit();
  }
}
